import FluentValidator from '@/app/module/fluentValidator'

class NewsBoardContentValidator extends FluentValidator {
  public validRequireNewsBoardContentName (key: string, value: string|number): boolean {
    this.errorMessages[key] = ''
    if (!value) {
      this.errorMessages[key] = '記事タイトルは必ず入力してください。'
      return true
    }
    return false
  }

  public validMaxLengthNewsBoardContentName (key: string, value: string): boolean {
    this.errorMessages[key] = ''
    if (value.length > 100) {
      this.errorMessages[key] = '記事タイトルは100文字以下で入力してください。'
      return true
    }
    return false
  }

  public validRequiredContentDate (key: string, value: string): boolean {
    this.errorMessages[key] = ''
    if (!value) {
      this.errorMessages[key] = '発行日は必ず選択してください。'
      return true
    }
    return false
  }

  public validRequireContentUrl (key: string, value: string|number): boolean {
    this.errorMessages[key] = ''
    if (!value) {
      this.errorMessages[key] = 'URLは必ず入力してください。'
      return true
    }
    return false
  }

  public validMaxLengthContentUrl (key: string, value: string): boolean {
    this.errorMessages[key] = ''
    if (value.length > 2000) {
      this.errorMessages[key] = 'URLは2000文字以下で入力してください。'
      return true
    }
    return false
  }

  public validRequireContentFile (key: string, value: any): boolean {
    this.errorMessages[key] = ''
    if (!value) {
      this.errorMessages[key] = 'ファイルは必ず選択してください。'
      return true
    }
    return false
  }

  public validFileTypeContentFile (key: string, value: any): boolean {
    this.errorMessages[key] = ''
    if (value.type !== 'application/pdf') {
      this.errorMessages[key] = '許可されている拡張子ではありません。(登録できる拡張子は .pdfです)'
      return true
    }
    return false
  }

  public validMaxLengthRemarks (key: string, value: string): boolean {
    this.errorMessages[key] = ''
    if (value.length > 500) {
      this.errorMessages[key] = '備考は500文字以下で入力してください。'
      return true
    }
    return false
  }

  public validMaxFileSize (key: string, value: number): boolean {
    this.errorMessages[key] = ''
    if (value >= 11000000) {
      this.errorMessages[key] = 'ファイルは10M以下のPDFを選択してください。'
      return true
    }
    return false
  }
}

export default new NewsBoardContentValidator()
